<script setup lang="ts">
defineProps<{
  size?: 'sm' | 'md' | 'lg'
  message?: string
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <div
      :class="[
        'animate-spin rounded-full border-b-2 border-molex-orange',
        {
          'h-6 w-6': size === 'sm',
          'h-10 w-10': size === 'md' || !size,
          'h-16 w-16': size === 'lg',
        },
      ]"
    ></div>
    <p v-if="message" class="mt-3 text-sm text-gray-500 dark:text-gray-400">{{ message }}</p>
  </div>
</template>
